export enum UoMTypesEnum {
  Kilogram = 'kg',
  Unit = 'u',
  Millimeter = 'mm',
  Centimeter = 'cm',
  Meter = 'm',
  Kilometer = 'km',
  Liter = 'L',
  Seconds = 's',
  Minutes = 'mn',
  Hour = 'h',
  Days = 'd',
  Ens = 'ens',
  SquareMeter = 'm²',
  SquareCentimeter = 'cm²',
  SquareMillimeter = 'mm²',
  CubicMeter = 'm³',
  CubicCentimeter = 'cm³',
  CubeMillimeter = 'mm³',
  Euro = '€',
  EuroPerKilogram = '€/kg',
  EuroPerUnit = '€/u',
  EuroPerMeter = '€/m',
  EuroPerKilometer = '€/km',
  EuroPerLiter = '€/L',
  EuroPerHour = '€/h',
  EuroPerEns = '€/ens',
  EuroPerSquareMeter = '€/m²',
  EuroPerCubicMeter = '€/m³',
  KilogramsPerMeter = 'kg/m',
  KilogramsPerCubicMeter = 'kg/m³',
  Percentage = '%',
  HoursPerSquareMeter = 'h/m²',
}
